export default __webpack_public_path__ + "static/media/logo-lydian-black.ce632ad8.png";